// extracted by mini-css-extract-plugin
export var dividerContainer = "_8s-0";
export var line = "_8s-1";